import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from 'react-i18next';

/**
 * Read-only view of the dedications attached to one entry of the host's list.
 * A standard event collapses every request for the same song into one row, so
 * there can be several of them.
 */
export const SongNotesModal = ({ eventSong, isKaraoke, onClose }) => {
  const { t } = useTranslation();

  const notes = eventSong?.guestNotes?.length
    ? eventSong.guestNotes
    : (eventSong?.guestNote ? [eventSong.guestNote] : []);

  return (
    <Modal isOpen={!!eventSong} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        {isKaraoke ? t('Note for the Host') : t('Dedication')}
      </ModalHeader>
      <ModalBody>
        <div className="mb-3 text-muted">
          {eventSong?.title} <span className="fw-light">- {eventSong?.artist}</span>
        </div>
        {notes.map((note, index) => (
          <div key={index} className="d-flex align-items-start gap-2 mb-2">
            <i className="ri-sticky-note-line text-muted flex-shrink-0 mt-1"></i>
            <div className="text-break fs-15">{note}</div>
          </div>
        ))}
      </ModalBody>
      <ModalFooter>
        <div className="hstack gap-2 justify-content-end">
          <button type="button" className="btn btn-label btn-light" onClick={onClose}>
            <i className="ri-close-circle-line label-icon align-middle fs-16 me-2"></i>{t('Close')}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};
